<template>
  <div
    :class="`content-section ${classes} ${no_margin ? '' : 'content-section--with-panel'} ${no_content_padding ? 'content-section--without-content-padding' : ''}`"
    compact
    :style="{
      '--background-color': background_color
    }"
  >
    <div
      v-if="title"
      :class="{
        'content-section__header': true,
        'content-section__header--without-content-padding': no_content_padding,
      }"
    >
      <vb-icon v-if="icon" :name="icon" :size="20" color="--primary" />
      <span class="content-section__title" v-html="title"></span>
    </div>
    <span
      v-if="description"
      :class="{
        'content-section__description': true,
        'content-section__description--without-content-padding': no_content_padding,
      }"
      v-html="description"
    ></span>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'content-section',
    props: {
      icon: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
      classes: {
        type: String,
        default: '',
      },
      no_margin: {
        type: Boolean,
        default: false,
      },
      no_content_padding: {
        type: Boolean,
        default: false,
      },
      background_color: {
        type: String,
        default: 'white'
      }
    },
  };
</script>

<style lang="scss" scoped>

  .content-section {
    margin-bottom: $grid-gutter-20;

    &--with-panel {
      padding: $grid-gutter-20;
      background-color: var(--background-color);
      border-radius: $border-radius-lg * 2;
    }

    &--without-content-padding {
      padding: 0 !important;
    }

    &__header {
      display: flex;
      gap: $grid-gutter-width / 3;
      align-items: center;

      &--without-content-padding {
        padding: ($grid-gutter-width / 2) ($grid-gutter-width / 2) 0 ($grid-gutter-width / 2);
      }
    }

    &__title {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-xl;
      line-height: normal;
    }

    &__description {
      font-size: $font-size-md;
      margin-bottom: $grid-gutter-width / 3;
      line-height: normal;

      &--without-content-padding {
        padding: 0 $grid-gutter-width / 2;
      }
    }
  }
</style>
